
import { ClimbingArea } from "../types"

export function apiDomain() {

  let prod = "api.climbingweather.com"
  let stage = "api.backcountryweather.com"
  if (window.location.hostname === "localhost") {
    return stage
  }
  if (window.location.hostname === "stage.climbingweather.com") {
    return stage
  }
  if (window.location.hostname === "backcountryweather.com") {
    return stage
  }
  if (window.location.hostname === "www.backcountryweather.com") {
    return stage
  }
  if (window.location.hostname === "cw-dev-336617.uc.r.appspot.com") {
    return stage
  }

  return prod
}

export function areaLink(area: ClimbingArea) {
    let areaCleaned = area.name.replace(/-/g, "|").replace(/\s/g, "-");
    let areaEncoded = encodeURIComponent(areaCleaned);
  
    let stateCleaned = area.adminAreaName.replace(/-/g, "|").replace(/\s/g, "-");
    let stateEncoded = encodeURIComponent(stateCleaned);
  
    return "/area/" + area.areaId + "/detail/" + area.country + "/" + stateEncoded + "/" + areaEncoded
  }

export function adminAreaLink(code: string) {
  return "/forecast-by-state/" + code
}
